import React, { useState, useCallback } from 'react'
import { AppSvg, ButtonVertical, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import { lang } from './lang'
import FreezeModal from './FreezeModal'
import UnfreezeModal from './UnfreezeModal'

interface Props {
    isDisabled?: boolean
    card?: GetCard
}

function Freeze({ card, isDisabled }: Props) {
    const isFreeze = card?.status === 'SUSPENDED'

    const [isFreezeOpen, setIsFreezeOpen] = useState(false)
    const [isUnfreezeOpen, setIsUnfreezeOpen] = useState(false)

    const onFreezeClose = useCallback(() => {
        setIsFreezeOpen(false)
    }, [])

    const onFreezeOpen = useCallback(() => {
        setIsFreezeOpen(true)
    }, [])

    const onUnfreezeClose = useCallback(() => {
        setIsUnfreezeOpen(false)
    }, [])

    const onUnfreezeOpen = useCallback(() => {
        setIsUnfreezeOpen(true)
    }, [])

    return (
        <>
            <FreezeModal isOpen={isFreezeOpen} onClose={onFreezeClose} card={card} />
            <UnfreezeModal isOpen={isUnfreezeOpen} onClose={onUnfreezeClose} />
            <ButtonVertical
                dataPointer={isFreeze ? 'unfreeze' : 'freeze'}
                label={
                    isFreeze ? <FormattedHTMLMessage {...lang.unfreeze} /> : <FormattedHTMLMessage {...lang.freeze} />
                }
                role="button"
                icon={
                    <AppSvg
                        svgName={isFreeze ? newIcons.ic24Unfreeze : newIcons.ic24Snowflake}
                        path="new-icons"
                        size={24}
                    />
                }
                onClick={isFreeze ? onUnfreezeOpen : onFreezeOpen}
                isDisabled={isDisabled}
            />
        </>
    )
}

export default Freeze
